import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../lib/api';

function getTrafficSource() {
  const ref = document.referrer;
  if (!ref) return 'direct';
  try {
    const url = new URL(ref);
    const host = url.hostname.toLowerCase();
    if (host.includes('google')) return 'google';
    if (host.includes('facebook') || host.includes('fb.com')) return 'facebook';
    if (host.includes('instagram')) return 'instagram';
    if (host.includes('twitter') || host.includes('x.com')) return 'twitter';
    if (host.includes('youtube')) return 'youtube';
    if (host.includes('reddit')) return 'reddit';
    if (host.includes('crownvic')) return 'direct';
    return host;
  } catch {
    return 'other';
  }
}

function getSessionId() {
  let id = sessionStorage.getItem('cvn_session');
  if (!id) {
    id = Math.random().toString(36).substring(2) + Date.now().toString(36);
    sessionStorage.setItem('cvn_session', id);
  }
  return id;
}

export function useAnalytics() {
  const location = useLocation();
  const scrollRef = useRef(0);
  const pageRef = useRef('');

  useEffect(() => {
    const page = location.pathname;
    if (page === pageRef.current) return;
    pageRef.current = page;
    scrollRef.current = 0;

    // Track page view
    api.post('/analytics/track', {
      page,
      source: getTrafficSource(),
      session_id: getSessionId(),
    }).catch(() => {});

    // Track scroll depth
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      const depth = Math.min(100, Math.round((scrollTop / docHeight) * 100));
      if (depth > scrollRef.current) {
        scrollRef.current = depth;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    // Send scroll depth on page leave
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollRef.current > 0) {
        api.post('/analytics/track', {
          page,
          source: getTrafficSource(),
          session_id: getSessionId(),
          scroll_depth: scrollRef.current,
        }).catch(() => {});
      }
    };
  }, [location.pathname]);
}
